/**
 * Created by m.igrachev on 6/19/2017.
 */
const documentedProperties = [
    {
        name: "children",
        type: "React.Children",
        defaultValue: "n/a",
        isRequired: "true",
        description:
            "Modal Footer component nests ModalSubmit, ModalCancel and other content, so some children are expected."
    },
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Extra css classes to be added to ModalFooter."
    },
    {
        name: "modalCancelClass",
        type: "String",
        defaultValue: '"ModalCancel"',
        isRequired: "false",
        description:
            "Defines the displayName of the React component that is rendered as ModalCancel. Useful when wrapping with React."
    },
    {
        name: "modalSubmitClass",
        type: "String",
        defaultValue: '"ModalSubmit"',
        isRequired: "false",
        description:
            "Defines the displayName of the React component that is rendered as ModalSubmit. Useful when wrapping with React."
    },
    {
        name: "onModalClose",
        type: "Function",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Expected to be supplied by Modal component. It cannot be overridden here."
    },
    {
        name: "onModalSubmit",
        type: "Function",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Expected to be supplied by Modal component. It cannot be overridden here."
    }
];

export default documentedProperties;
